var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "funnel_1_",
    "data-name": "funnel (1)",
    d: "M1.5,1.5A.5.5,0,0,1,2,1H14a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-.128.334L10,8.692V13.5a.5.5,0,0,1-.342.474l-3,1A.5.5,0,0,1,6,14.5V8.692L1.628,3.834A.5.5,0,0,1,1.5,3.5Zm1,.5V3.308L6.872,8.166A.5.5,0,0,1,7,8.5v5.306l2-.666V8.5a.5.5,0,0,1,.128-.334L13.5,3.308V2Z",
    transform: "translate(-1.5 -1)",
    fill: "#5b5b5b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFunnel);
export default __webpack_public_path__ + "static/media/icon-funnel.4e3260d212229d59868824bd9bb914f2.svg";
export { ForwardRef as ReactComponent };